// extracted by mini-css-extract-plugin
export default {"image":"EpcLogin_image__OsaBi"};